export default "__VITE_ASSET__DT6rwz0C__"